import React from "react";

import {
  Legend,
  RadialBar,
  RadialBarChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const Chart = ({ data }) => (
  <ResponsiveContainer className="flex-1 mb-4">
    <RadialBarChart
      innerRadius="10%"
      outerRadius="100%"
      data={data}
      startAngle={180}
      endAngle={270}
      cx="60%"
      cy="15%"
    >
      <RadialBar
        minAngle={15}
        background
        clockWise
        dataKey="variables"
        label={{
          fill: "#000",
          position: "end",
        }}
      />
      <Legend
        iconSize={10}
        layout="horizontal"
        verticalAlign="bottom"
        align="center"
      />
      <Tooltip formatter={value => [value, "Variables"]} />
    </RadialBarChart>
  </ResponsiveContainer>
);

export default Chart;
